import { phone , password ,username, qrcode, idCard, isEmail} from './validators'
import Vue from 'vue'
import {createAPI, Toast} from 'cube-ui'
createAPI(Vue, Toast, ['click'], true)

const loading = Toast.$create({
  txt: '努力加载中...',
  mask: true,
  time: 0
})

// console.log(phone)
let result = {
    phoneStatus: false,
    passwordStatus: false,
    qrCodeStatus: false,
    UsernameStatus: false,
    PasswordOncestatus: false,
    isall: false,
    resetPasssword: false,
    idCardStatus: false,
    msg: ''
}
let _this = this;
export default new class {
  isPhone (value) {
    // console.log(value)
    if (!value) {
      result.phoneStatus = false;
      result.msg = '手机号不能为空'
      this.showToastTxtOnly(result.msg)
    } else if (!phone.test(value)) {
      result.phoneStatus = false;
      result.msg = '请输入合法的手机号'
      this.showToastTxtOnly(result.msg)
    } else if (phone.test(value) && value != '') {
      result.phoneStatus = true;
      result.msg = ''
    }
    return result;
  }
  isIdcard(value){
    if (!value) {
      result.idCardStatus = false;
      result.msg = '身份证号不能为空'
      this.showToastTxtOnly(result.msg)
    } else if (!idCard.test(value)) {
      result.idCardStatus = false;
      result.msg = '请输入正确的身份证号'
      this.showToastTxtOnly(result.msg)
    } else if (idCard.test(value) && value != '') {
      result.idCardStatus = true;
      result.msg = ''
    }
    return result;
  }
  isUsername (value) {
    // console.log(value)
    if (!value) {
      result.msg = "用户名不能为空"
      this.showToastTxtOnly(result.msg)
    }else {
      result.UsernameStatus = true
      result.msg = ''
    }
    // else if (!username.test(value)){
    //   result.UsernameStatus = false
    //   result.msg = "用户名格式不正确"
    //   this.showToastTxtOnly(result.msg)
    // }
    return result;
    // result.passwordonce = true;
  }
  isPassword (value) {
    // console.log(value)
    if (!value) {
      result.passwordStatus = false;
      result.msg = '密码不能为空'
      this.showToastTxtOnly(result.msg)
    } else if (!password.test(value) || value.length < 6) {
      result.passwordStatus = false;
      result.msg = '密码必须不能少于6位~'
      this.showToastTxtOnly(result.msg)
    } else {
        result.passwordStatus = true;
        result.msg = ''
    }
    return result;
  }
  isqrCode (value) {
    // console.log(value)
    if (!value) {
      result.qrCodeStatus = false;
      result.msg = "验证码不能为空"
      this.showToastTxtOnly(result.msg)
    } else {
      result.qrCodeStatus = true
      result.msg = ''
    }
    return result;
    // else if (!qrcode.test(value)) {
    //   result.qrCodeStatus = false;
    //   result.msg = "验证码格式不正确"
    // }
  }

  isPasswordOnce (value,againName) {
    // console.log(value)
    if (!value) {
      result.PasswordOncestatus = false;
      result.msg = '密码不能为空'
      this.showToastTxtOnly(result.msg)
    } else if (!password.test(value) || value.length < 6) {
      result.PasswordOncestatus = false;
      result.msg = '密码必须不能少于6位~'
      this.showToastTxtOnly(result.msg)
    } else if (againName != value) {
      result.PasswordOncestatus = false;
      result.msg = '两次密码不一致'
      this.showToastTxtOnly(result.msg)
    } else if (password.test(value) && value != '' && value.length >= 6 && againName == value){
      result.PasswordOncestatus = true;
      result.msg = ''
    }
    return result;
  }
  isAllvalidate () {
    //
    if(result.phoneStatus && result.qrCodeStatus && result.passwordStatus && result.UsernameStatus && result.PasswordOncestatus){
      result.isall = true;
      // 处理注册逻辑
    } else {
      result.isall = false;
    }
    return result
  }
  isLogin () {
    if( (result.passwordStatus && result.UsernameStatus) || (result.phoneStatus && result.qrCodeStatus)){
      result.isall = true;
      // 处理登录逻辑
    } else {
      result.isall = false;
    }
    return result
  }
  isResetPhone () {
    if(result.phoneStatus && result.qrCodeStatus){
      result.isall = true;
      // 处理登录逻辑
    } else {
      result.isall = false;
    }
    return result
  }
  isResetPassword () {
    //
    if(result.passwordStatus && result.PasswordOncestatus){
      result.resetPasssword = true;
      // 处理注册逻辑
    } else {
      result.resetPasssword = false;
    }
    return result
  }
  showToastTxtOnly(txt){
    Toast.$create({
      txt: txt,
      type: 'txt',
      time: 1500
    }).show()
  }

}
